import {
  formatDate,
  formatDateOnly,
  formatDateOnlyMysql,
  calculateDuration,
  formatTimeAgo,
  formatTimeOnly,
  formatDateTimeSql
} from "../helpers/date";
import { formatClient, formatEoc, formatMrn } from "../helpers/episodeOfCare";
import { formatUser } from "../helpers/user";
import { toCurrencyValue } from "../helpers/general";
export default {
  install: Vue => {
    Vue.mixin({
      methods: {
        formatDate(date) {
          return formatDate(date);
        },
        formatDateOnly(date) {
          return formatDateOnly(date);
        },
        formatDateOnlyMysql(date) {
          return formatDateOnlyMysql(date);
        },
        formatTimeOnly(date) {
          return formatTimeOnly(date);
        },
        formatDateTimeSql(date) {
          return formatDateTimeSql(date);
        },
        calculateDuration(dateFrom, dateTo) {
          return calculateDuration(dateFrom, dateTo);
        },
        formatClient(firstName, middleName, preferredName, lastName, mrn) {
          return formatClient(
            firstName,
            middleName,
            preferredName,
            lastName,
            mrn
          );
        },
        formatEoc(firstName, lastName, mrn, eocn) {
          return formatEoc(firstName, lastName, mrn, eocn);
        },
        formatEocObj(episodeOfCare) {
          return formatEoc(
            episodeOfCare.patient.firstName,
            episodeOfCare.patient.lastName,
            episodeOfCare.patient.mrn,
            episodeOfCare.eocn
          );
        },
        formatMrn(mrn, eocn) {
          return formatMrn(mrn, eocn);
        },
        formatTimeAgo(date) {
          return formatTimeAgo(date);
        },
        formatUser(user) {
          return formatUser(user);
        },
        toCurrencyValue(value) {
          return toCurrencyValue(value);
        }
      }
    });
  }
};
